import { USER_NAME } from "../../../utils/constants";
import { useReports } from "../context/ReportsContext";

const Eligible = ({ eligibility }) => {
  const { subscribeToReports } = useReports();

  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full text-center text-lg font-semibold text-p300">
        🔓Unlocked!
      </div>
      <div className="mt-3 px-8 text-center text-sm font-medium text-n400">
        You have completed 5 trades this month and unlocked daily market reports
        for free!
      </div>
      <div className="mt-5 w-full h-px bg-n200"></div>
      <div className="mt-6 w-full">
        <button
          onClick={() => subscribeToReports(USER_NAME, "subscription")}
          className="w-full py-2 px-4 text-xs font-semibold bg-blue-100 text-p300 rounded">
          Unlock reports
        </button>
      </div>
    </div>
  );
};

export default Eligible;
